<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <NetworkDeviceAdd
      v-if="showAddNetworkDevice"
      :visible="showAddNetworkDevice"
      @updated="
        showAddNetworkDevice = false;
        $router.push({ query: {} });
        applyFilters();
      "
    />
    <DeviceTunnelAdd
      v-if="
        showTempTunnel &&
          hasPrivilege('network_devices_generate_tunnel') &&
          this.$store.getters.settings.type != 'local'
      "
      :visible="showTempTunnel"
      :networkdevice="temp_tunnel_network_device"
      @updated="
        showTempTunnel = false;
        temp_tunnel_network_device = null;
        applyFilters();
      "
      @close="showTempTunnel = false"
    />
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="dt-buttons flex" bis_skin_checked="1">
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    v-if="hasPrivilege('network_devices_edit_network_devices')"
                    @click="openAddNetworkDeviceModal()"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{
                        $t("network_devices.add_network_device")
                      }}</span>
                    </span>
                  </button>
                  <div class="d-flex align-items-center mx-4">
                    <InfoButton :url="'https://youtu.be/kEl_2Hzg6-g'" />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    type="button"
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i>Print</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i>Csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-export me-2"></i>Excel</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i>Pdf</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    v-if="
                      hasPrivilege(
                        'network_devices_view_search_network_devices',
                      )
                    "
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="DataTables_Table_0"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting" v-if="columns.name.enabled">
                      {{ $t("network_devices.name") }}
                    </th>
                    <th class="sorting" v-if="columns.type.enabled">
                      {{ $t("network_devices.type") }}
                    </th>
                    <th class="sorting" v-if="columns.ip.enabled">
                      {{ $t("network_devices.ip") }}
                    </th>
                    <th class="sorting" v-if="columns.username.enabled">
                      {{ $t("network_devices.username") }}
                    </th>
                    <th class="sorting" v-if="columns.password.enabled">
                      {{ $t("network_devices.password") }}
                    </th>
                    <th class="sorting" v-if="columns.tunnel_url.enabled">
                      {{ $t("network_devices.tunnel_url") }}
                    </th>
                    <th class="sorting" v-if="columns.status.enabled">
                      {{ $t("network_devices.status") }}
                    </th>
                  </tr>
                  <tr
                    v-if="
                      hasPrivilege(
                        'network_devices_view_search_network_devices',
                      )
                    "
                  >
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.name"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.type.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        class="form-select"
                        v-model="filters.type"
                        @change="applyFilters"
                      >
                        <option :value="null">{{ $t("control.all") }}</option>
                        <option value="switch">{{
                          $t("network_devices.types.switch")
                        }}</option>
                        <option value="router">{{
                          $t("network_devices.types.router")
                        }}</option>
                        <option value="server">{{
                          $t("network_devices.types.server")
                        }}</option>
                        <option value="dish">{{
                          $t("network_devices.types.dish")
                        }}</option>
                        <option value="ip">{{
                          $t("network_devices.types.ap")
                        }}</option>
                        <option value="other">{{
                          $t("network_devices.types.other")
                        }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.ip.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.ip"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.username.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.password.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.tunnel_url.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.status.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr
                    v-for="(network_device, index) in dataList"
                    :key="network_device.id"
                  >
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li>
                            <button
                              @click="openAddNetworkDeviceModal(network_device)"
                              v-if="
                                hasPrivilege(
                                  'network_devices_edit_network_devices',
                                )
                              "
                              class="dropdown-item text-primary"
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="
                                openAddNetworkDeviceModal(
                                  network_device,
                                  'copy',
                                )
                              "
                              v-if="
                                hasPrivilege(
                                  'network_devices_edit_network_devices',
                                )
                              "
                              class="dropdown-item text-primary"
                            >
                              <i class="ti ti-clipboard me-2"></i
                              >{{ $t("actions.copy") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              hasPrivilege('network_devices_generate_tunnel') &&
                                this.$store.getters.settings.type != 'local'
                            "
                          >
                            <button
                              @click="openTempTunnelModal(network_device)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-link me-2"></i
                              >{{
                                network_device.tunnel
                                  ? $t("nases.remote_tunnel")
                                  : $t("nases.generate_remote_tunnel")
                              }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="deleteData(network_device)"
                              v-if="
                                hasPrivilege(
                                  'network_devices_delete_network_devices',
                                )
                              "
                              class="dropdown-item text-danger"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="network_device.selected"
                        @click="selectData(network_device)"
                      />
                    </td>
                    <td scope="row" v-if="columns.name.enabled">
                      <a
                        :href="`?network_device_id=${network_device.id}`"
                        @click.prevent="
                          openAddNetworkDeviceModal(network_device)
                        "
                        >{{ network_device.name }}</a
                      >
                    </td>
                    <td v-if="columns.type.enabled">
                      {{ $t(`network_devices.types.${network_device.type}`) }}
                    </td>
                    <td v-if="columns.ip.enabled">
                      {{ network_device.ip_address }}
                    </td>
                    <td v-if="columns.username.enabled">
                      {{ network_device.username }}
                    </td>
                    <td v-if="columns.password.enabled">
                      {{ network_device.password }}
                    </td>
                    <td v-if="columns.tunnel_url.enabled">
                      <div v-if="network_device.tunnel">
                        <span class="badge bg-label-secondary me-1">{{
                          network_device.tunnel.internal_ip +
                            ":" +
                            network_device.tunnel.internal_port
                        }}</span>
                        <a
                          @click.prevent="openNewTab(network_device.tunnel.url)"
                          :href="network_device.tunnel.url"
                          >{{ network_device.tunnel.url }}</a
                        >
                      </div>
                      <div v-else>
                        <button
                          @click="openTempTunnelModal(network_device)"
                          v-if="
                            hasPrivilege('network_devices_generate_tunnel') &&
                              this.$store.getters.settings.type != 'local'
                          "
                          class="btn btn-success btn-sm"
                        >
                          <i class="ti ti-link me-2"></i
                          >{{ $t("network_devices.generate") }}
                        </button>
                      </div>
                    </td>
                    <td v-if="columns.status.enabled">
                      <div v-if="hasPrivilege('network_devices_view_status')">
                        <span
                          v-if="network_device.status === true"
                          class="badge bg-label-success me-1"
                          >{{ network_device.time }}</span
                        >
                        <span
                          v-if="network_device.status === false"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.offline") }}</span
                        >
                        <span
                          v-if="network_device.status === 'loading'"
                          class="badge me-1 text-primary"
                          ><div class="spinner-border"></div
                        ></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { hasPrivilege } from "../global_constants.js";
import { mapGetters } from "vuex";
import NetworkDeviceAdd from "../components/modals/network-device-add.vue";
import DeviceTunnelAdd from "../components/modals/device-tunnel-add.vue";
export default {
  components: {
    DeviceTunnelAdd,
    NetworkDeviceAdd,
  },
  name: "NetworkDevices",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDeleteAll: false,
      showContext: false,
      showQrCode: false,
      selectedNetworkDevice: null,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        name: "",
        ip: "",
        type: null,
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      showAddNas: false,
      showAddNetworkDevice: false,
      showTempTunnel: false,
      temp_tunnel_nas: null,
      temp_tunnel_network_device: null,
      columns: {
        name: { name: this.$t("network_devices.name"), enabled: true },
        ip: { name: this.$t("network_devices.ip"), enabled: true },
        type: { name: this.$t("network_devices.type"), enabled: true },
        username: { name: this.$t("network_devices.username"), enabled: true },
        password: { name: this.$t("network_devices.password"), enabled: true },
        status: { name: this.$t("network_devices.status"), enabled: true },
        tunnel_url: {
          name: this.$t("network_devices.tunnel_url"),
          enabled: true,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
    };
  },
  async created() {
    this.prepareFilters();
    this.applyFilters();
    // this.prepareColumns();
    if (this.$route.query.network_device_id) {
      this.openAddNetworkDeviceModal({
        id: this.$route.query.network_device_id,
      });
    }
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      this.applyFilters();
    },
    async openAddNetworkDeviceModal(network_device = null, operation = "new") {
      if (network_device) {
        this.$router.push({
          query: { network_device_id: network_device.id, operation: operation },
        });
        await this.$nextTick();
      }
      this.showAddNetworkDevice = true;
      await this.$nextTick();
      var modalElement = document.getElementById("add-network-device");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddNetworkDevice = false;
        this.$router.push({
          query: {},
        });
      });
      modalInstance.show();
    },
    async openTempTunnelModal(network_device = null) {
      this.temp_tunnel_network_device = network_device;
      this.showTempTunnel = true;
      await this.$nextTick();
      var modalElement = document.getElementById("add-device-temp-tunnel");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showTempTunnel = false;
        this.temp_tunnel_network_device = null;
        this.$router.push({
          query: {},
        });
      });
      modalInstance.show();
    },
    prepareFilters() {
      var filters = localStorage.getItem("network_devices_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("network_devices_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: { name: this.$t("nases.name"), enabled: cols[0].enabled },
          ip: { name: this.$t("nases.ip"), enabled: cols[1].enabled },
          secret: { name: this.$t("nases.secret"), enabled: cols[2].enabled },
          username: {
            name: this.$t("nases.username"),
            enabled: cols[3].enabled,
          },
          password: {
            name: this.$t("nases.password"),
            enabled: cols[4].enabled,
          },
          api_port: {
            name: this.$t("nases.api_port"),
            enabled: cols[5].enabled,
          },
          community: {
            name: this.$t("nases.community"),
            enabled: cols[6].enabled,
          },
          legacy: { name: this.$t("nases.version"), enabled: cols[7].enabled },
          allowed_admins: {
            name: this.$t("nases.allowed_admins"),
            enabled: cols[8].enabled,
          },
          allowed_profiles: {
            name: this.$t("nases.allowed_profiles"),
            enabled: cols[9].enabled,
          },
          online_sessions: {
            name: this.$t("nases.online_sessions"),
            enabled: cols[10] != null ? cols[10].enabled : true,
          },
          online: { name: this.$t("nases.status"), enabled: cols[11].enabled },
          api_connected: {
            name: this.$t("nases.api"),
            enabled: cols[12] != null ? cols[12].enabled : true,
          },
          wa_status: {
            name: this.$t("nases.whatsapp_status"),
            enabled: cols[13] != null ? cols[13].enabled : false,
          },
          wa_name: {
            name: this.$t("nases.whatsapp_network_name"),
            enabled: cols[14] != null ? cols[14].enabled : false,
          },
          settings: {
            name: this.$t("nases.settings"),
            enabled: cols[15] != null ? cols[15].enabled : true,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = `nases/devices?filters=1`;
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.ip != "")
        requestString += `&ip_address=${this.filters.ip}`;
      if (this.filters.ip != null)
        requestString += `&type=${this.filters.type}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem(
          "network_devices_filters",
          JSON.stringify(this.filters),
        );
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      this.meta = response.data.meta;
      this.loading = false;
      this.dataList.forEach(async (nas) => {
        await this.pingHost(nas);
      });
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.loading = true;
      var requestString = `nases?rows=${rows}&page=${currentPage}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    async deleteData(network_device) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "network_devices.this_will_delete_network_device_permanently",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(
              `nases/devices/${network_device.id}`,
            );
            if (response.status == 200) {
              this.fetchData();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t(
                "network_devices.network_device_has_been_deleted_successfully",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns() {
      localStorage.setItem(
        "network_devices_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    async pingHost(network_device) {
      try {
        const response = await axios.get(
          `nases/devices/${network_device.id}/ping`,
        );
        if (response.status == 200) {
          network_device.status = response.data.data.received > 0;
          network_device.time = response.data.data.time;
          network_device.loss = response.data.data["paket-loss"];
          return response.data.status == "up";
        } else {
          network_device.status = false;
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem(
        "network_devices_filters",
        JSON.stringify(this.filters),
      );
    },
    openNewTab(url) {
      window.open(url, "_blank").focus();
    },
  },
};
</script>
